<!-- eslint-disable no-undef -->
<template>
  <div @click="dataLayerPush()">
    <div v-if="engLogotypeLocales.includes(Trans.currentLocale)">
      <img
        v-show="!openedMenu"
        class="d-xl-none"
        :src="require('@/assets/img/logo_eng.svg')"
        alt="logo"
      />
      <img
        v-show="openedMenu"
        class="d-xl-none"
        :src="require('@/assets/img/logo_white_eng.svg')"
        alt="logo"
      />
      <img
        class="d-none d-xl-block"
        :src="require('@/assets/img/logo_eng.svg')"
        alt="logo"
      />
    </div>
    <div v-else>
      <img
        v-show="!openedMenu"
        class="d-xl-none"
        :src="require('@/assets/img/logo.svg')"
        alt="logo"
      />
      <img
        v-show="openedMenu"
        class="d-xl-none"
        :src="require('@/assets/img/logo_white.svg')"
        alt="logo"
      />
      <img
        class="d-none d-xl-block"
        :src="require('@/assets/img/logo.svg')"
        alt="logo"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLogo',
  props: {
    openedMenu: { type: Boolean, default: false },
  },
  computed: {
    engLogotypeLocales() {
      return ['lv', 'lt', 'et', 'az', 'ka', 'uz', 'ky', 'en']
    },
  },
  methods: {
    dataLayerPush() {
      if (this.$gtm) {
        this.$gtm.push({
          event: 'ev_logo',
        })
      }
      if (this.$route.name !== this.helpers.buildRoute({ name: 'Home' }).name) {
        this.$router.push(this.helpers.buildRoute({ name: 'Home' }))
      }
    },
  },
}
</script>
<style lang="scss" scoped>
img {
  cursor: pointer;
  width: 112px;
  @media screen and (max-width: 1220px) {
    width: 112px;
  }
  @media screen and (max-width: 743px) {
    width: 84px;
  }
}
</style>
